import styled from 'styled-components';

import { MemoryIcon } from '@genially/icons';

export const StyledMemoryIcon = styled(MemoryIcon)(({ $color }) => ({
  color: $color,
}));
